// This file is used to ensure that jQuery and angular are loaded in the correct order. jQuery must be loaded before
// AngularJS in order for it to use jQuery over jqLite

// manually assign jQuery global variable - this doesn't happen by default with webpack since it uses modules for building its bundle instead of concatenation
global.jQuery = global.$ = require('jquery')

module.exports = global.angular = require('actual-angular')
